import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import VideoEditForm from "../../components/videos/VideoEditForm";

export default function EditVideo() {
  useEffect(() => {
    document.title = "Edit video";
  });
  return (
    <>
      <Navbar />
      <Container>
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Edit Video
          </h1>
          <VideoEditForm />
        </main>
      </Container>
    </>
  );
}
